<template>
  <div class="core-wrapper md:px-12 lg:px-24">
    <div
      v-for="(versionUpdate, index) in versionUpdates"
      :key="index"
      class="core-version-update mt-4 md:flex flex-row items-center">
      <div class="hidden md:flex">
        <IconAlertTriangle class="mr-4 h-6 w-6 text-version-dark" stroke="1.8" />
      </div>
      <div class="flex grow flex-col pr-10">
        <div class="font-bold text-version-dark">
          {{ $t('version.office_banner.title') }}
        </div>
        <div class="text-version-dark">
          {{ getPartTitle(versionUpdate.part, wtGeneral) }} v{{ versionUpdate.version }}
          <br />
          {{ versionUpdate.description }}
        </div>
      </div>
      <div class="mt-4 mr-4 flex flex-row md:mt-0">
        <button
          class="core-link mr-8 h-[48px] w-full text-right md:text-left hover:text-version-dark"
          @click="onIgnoreVersion(versionUpdate)">
          {{ $t('version.office_banner.ignore_update') }}
        </button>

        <button
          class="core-button core-action-button core-action-button--primary h-[48px]"
          @click="onUpdateVersion(versionUpdate)">
          {{ $t('version.office_banner.apply_update') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { IconAlertTriangle } from '@tabler/icons-vue'
import type { PropType } from 'vue'
import { getPartTitle } from '@/helpers/shared'
import { useWidgetText } from '@/helpers/useWidgetText'

const { wt: wtGeneral } = useWidgetText('widget-texts-general')

export interface UpdateDataType {
  version: string
  type: string
  part: string
  description: string
}

defineProps({
  versionUpdates: Object as PropType<UpdateDataType[]>,
})
const emits = defineEmits(['onUpdate', 'onIgnore'])

const onIgnoreVersion = function (update: UpdateDataType) {
  emits('onIgnore', update)
}
const onUpdateVersion = function (update: UpdateDataType) {
  emits('onUpdate', update)
}
</script>

<style lang="postcss" scoped>
.core-version-update {
  @apply bg-primary-light py-4 px-5;
}

.core-button {
  @apply w-full px-6 py-3 md:w-auto;
}
</style>
